module.exports = __webpack_public_path__ + "img/iot_record1.c4a91ad7.png";